import { InspectionFormType } from '@pages/inspection-detail-page-v2/inspection-util';
import { computed, signal } from '@angular/core';
import { Subscription } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';

export class InspectionFormWrapper {
  private readonly _enabled = signal(false);
  private readonly _form = signal<InspectionFormType | undefined>(undefined);
  private readonly _value = signal<InspectionFormType['value'] | undefined>(undefined);

  private _subscription: Subscription | null = null;

  setForm(form: InspectionFormType | undefined) {
    this._form.set(form);
    this._enabled.set(form?.enabled ?? false);
    if (form) {
      this._value.set(form.value);
      this._subscription?.unsubscribe();
      this._subscription = form.valueChanges.subscribe((formValue) => {
        this._value.set(formValue);
      });
    }
  }

  readonly form = this._form.asReadonly();

  /** @deprecated Use form signal instead */
  readonly form$ = toObservable(this.form);

  readonly value = this._value.asReadonly();

  readonly controls = computed(() => this.form()?.controls);

  readonly enabled = this._enabled.asReadonly();

  /** @deprecated Use enabled signal instead */
  readonly enabled$ = toObservable(this.enabled);

  readonly disabled = computed(() => !this.enabled());

  readonly valid = computed(() => this._form()?.valid ?? false);

  readonly dirty = computed(() => this._form()?.dirty ?? false);

  updateValueAndValidity(opts?: {
    onlySelf?: boolean;
    emitEvent?: boolean;
  }): void {
    this.form()?.updateValueAndValidity(opts);
  }

  enable(): void {
    this.form()?.enable({ emitEvent: false });
    this._enabled.set(true);

    const id = this.value()?.id;
    if (id) {
      this.form()?.get('building')?.disable();
      this.form()?.get('inspectionType')?.disable();
    }
  }

  disable(): void {
    this.form()?.disable({ emitEvent: false });
    this._enabled.set(false);
  }

  markAllAsTouched(): void {
    this.form()?.markAllAsTouched();
  }

  async getMappedValue() {
    const form = this.form();
    if (!form) throw new Error('Form is not defined');
    return form.getMappedValue();
  }
}
